import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import TabsSchool from "./TabsSchool";
import TabsAdminFee from "./TabsAdminFee";
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';



function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ py: 2.4 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

export default function EnrollmentTabs({ formik, academicYearId, gradeId, listPaymentData, setListPaymentData, academicYearVal, required, value, setValue, checkedAdditionalFee }) {
    const theme = useTheme();


    const [quarterVal, setQuarterVal] = useState({ id: "", title: "" });
    const [discountVal, setDiscountVal] = useState({ id: "", title: "" });
    const [academicTermVal, setAcademicTermVal] = useState({ id: "", title: "" });
    const [monthByQuarterVal, setMonthByQuarterVal] = useState({ id: "", title: "" });

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        if (checkedAdditionalFee) {
            setValue(1);
            setQuarterVal({ id: "", title: "" });
            setDiscountVal({ id: "", title: "" });
            setAcademicTermVal({ id: "", title: "" });
            setMonthByQuarterVal({ id: "", title: "" });
        }
    }, [checkedAdditionalFee]);
    // console.log("ET listPaymentData::", listPaymentData);
    return (
        <Box sx={{ bgcolor: 'background.paper', mt: 4.5 }}>

            {
                checkedAdditionalFee ?
                    <Box sx={{ borderBottom: 2, borderColor: 'divider', position: "relative", width: "100%" }}>
                        <Tabs
                            value={1}
                            textColor="inherit"
                            variant="fullWidth"
                            aria-label="full width tabs example"
                            sx={{ position: "absolute", bottom: -2, width: "100%" }}

                        >
                            <Tab label="Additional Fees" {...a11yProps(1)} sx={{ fontWeight: "bold", width: "100%", color: "#1976d2 !important", bgcolor: "#E5F4FF !important" }} />
                        </Tabs>
                    </Box>
                    :
                    <Box sx={{ borderBottom: 2, borderColor: 'divider', position: "relative", width: "100%" }}>
                        <Tabs
                            value={value}
                            textColor="inherit"
                            variant="fullWidth"
                            onChange={handleChange}
                            aria-label="full width tabs example"
                            sx={{ position: "absolute", bottom: -2, width: "100%" }}
                        >
                            <Tab label="Tuition Fee" {...a11yProps(0)} sx={{ fontWeight: "bold", width: "50%", color: value === 0 ? "#1976d2 !important" : "", bgcolor: value === 0 ? "#E5F4FF !important" : "" }} />
                            <Tab label="Additional Fees" {...a11yProps(1)} sx={{ fontWeight: "bold", width: "50%", color: value === 1 ? "#1976d2 !important" : "", bgcolor: value === 1 ? "#E5F4FF !important" : "" }} />
                        </Tabs>
                    </Box>
            }
            <TabPanel
                index={0}
                value={value}
                dir={theme.direction}
            >
                <TabsSchool
                    formik={formik}
                    gradeId={gradeId}
                    quarterVal={quarterVal}
                    discountVal={discountVal}
                    setQuarterVal={setQuarterVal}
                    academicYearId={academicYearId}
                    setDiscountVal={setDiscountVal}
                    academicYearVal={academicYearVal}
                    academicTermVal={academicTermVal}
                    monthByQuarterVal={monthByQuarterVal}
                    setAcademicTermVal={setAcademicTermVal}
                    setMonthByQuarterVal={setMonthByQuarterVal}

                />
            </TabPanel>

            <TabPanel
                index={1}
                value={value}
                dir={theme.direction}
            >
                <TabsAdminFee listPaymentData={listPaymentData} setListPaymentData={setListPaymentData} required={required} />
            </TabPanel>

        </Box>
    );
}